import { Link } from "react-router-dom";
import { Heading, useColorModeValue, useToast, VStack } from "@chakra-ui/react";
import {
  Flex,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Drawer,
  Avatar,
  DrawerBody,
  DrawerHeader,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Tooltip,
  Center,
} from "@chakra-ui/react";
import { HiChevronDown } from "react-icons/hi2";
import { TbSettingsFilled } from "react-icons/tb";
import { RiNotification4Fill } from "react-icons/ri";
import { MdOutlineLogout, MdOutlineSegment } from "react-icons/md";
import { MdManageAccounts } from "react-icons/md";
import { useContext, useState } from "react";
import { AuthContext } from "../providers/AuthValidationLayer";
import { SidebarTab } from "./SidebarTab";
import { Accordion } from "@chakra-ui/react";
import { useFilteredMenu } from "../hooks/useFilteredMenu";
import { LogoutAlertDialog } from "./LogoutAlertDialog";
const SERVER = import.meta.env.VITE_API_URL;

const Navbar = () => {
  const toast = useToast();
  const { user } = useContext(AuthContext);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const onCloseAlert = () => setIsAlertOpen(false);
  const onOpenAlert = () => setIsAlertOpen(true);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const filteredMenu = useFilteredMenu();

  const logOut = async () => {
    try {
      let token = localStorage.getItem("prima_session");
      if (!token) {
        return toast({
          title: "Error",
          description: "Token is missing. Unable to log out.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }

      let res = await fetch(`${SERVER}/auth/logout`, {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });

      const data = await res.json();
      if (res.ok && data.success) {
        localStorage.removeItem("prima_session");
        localStorage.removeItem("prima_user"); // Also clear cached user data
        sessionStorage.clear();
        // The login also set a prima_session cookie; clear it so no request carries the old token
        document.cookie = "prima_session=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict";
        // Go straight to the login page (shown at the app root when there is no session)
        window.location.replace("/");
      } else {
        toast({
          title: "Error",
          description: data.message || "Failed to log out. Please try again.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Logout error:", error);
      toast({
        title: "Error",
        description: "An unexpected error occurred during logout.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex
      userSelect={"none"}
      h={14}
      position={"fixed"}
      inset={0}
      bg={useColorModeValue("white", "black")}
      alignItems={"center"}
      fontSize={18}
      color={"brand.text.secondary"}
      justifyContent={"space-between"}
      px={2}
      boxShadow={"sm"}
      zIndex={900}
    >
      <Drawer placement={"left"} onClose={onClose} isOpen={isOpen}>
        <DrawerContent
          zIndex={900}
          bg={useColorModeValue("brand.accent", "brand.text.primary")}
          color={useColorModeValue("brand.text.primary", "white")}
          w={250}
          maxW={250}
          boxShadow={"rgba(0, 0, 0, 0.05) 0px 0px 0px 1px"}
          p={0}
        >
          <DrawerHeader p={0}>
            <VStack spacing={2} align="flex-start" p={4} w="full">
              {/* Drawer Close Button Section */}
              <Flex
                align="center"
                justify="flex-start"
                justifyContent={"flex-start"}
                w="full"
                p={2}
              >
                <DrawerCloseButton color={"white"}></DrawerCloseButton>
              </Flex>

              {/* Heading Section */}
              <Flex
                align="center"
                justify="center"
                w="full"
                p={2}
                color={useColorModeValue("brand.text.primary", "white")}
                fontSize="20px"
              >
                <Text
                  fontSize="1rem"
                  textAlign="center"
                  fontWeight="bold"
                  color="white"
                >
                  Prima Travels
                </Text>
              </Flex>
            </VStack>
          </DrawerHeader>

          <DrawerBody userSelect={"none"} p={0}>
            {/* <Box px={3} mb={3}>
              <Input placeholder="Search" borderRadius="0" />
            </Box> */}
            <Accordion allowToggle p={0}>
              {filteredMenu?.map((item, index) => (
                <SidebarTab data={item} key={index} />
              ))}
            </Accordion>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <HStack spacing={4}>
        <Text display={["block", "block", "block", "none"]}>
          <MdOutlineSegment
            onClick={onOpen}
            fontSize={22}
            cursor={"pointer"}
            color={useColorModeValue("brand.text.primary", "white")}
          />
        </Text>
        <Flex
          color={"brand.text.primary"}
          alignItems={"center"}
          my={4}
          fontSize={20}
          gap={1}
        >
          <Text
            fontSize={{
              base: "0.75rem",
              sm: "1rem",
              md: "1.25rem",
              lg: "1.5rem",
            }}
            textAlign="center"
            fontWeight="bold"
            color="brand.accent"
          >
            Prima Travels
          </Text>
        </Flex>
        <Heading
          fontSize="lg"
          mb={1}
          color={"#333B69"}
          alignSelf={"center"}
          ml={"6rem"}
        >
          Welcome Back Admin 👋
        </Heading>
      </HStack>

      <HStack alignItems={"center"} spacing={6}>
        {/* <ToggleDarkMode /> */}
        <Flex alignItems={"center"} gap={6}>
          {/* <Tooltip
            hasArrow
            fontWeight={400}
            borderRadius={"6px"}
            fontSize={"sm"}
            px={4}
            py={1.5}
            label="History"
          >
            <Link to={"/history"} color={useColorModeValue("black", "white")}>
              <Text
                fontSize={"14px"}
                fontWeight={500}
                cursor={"pointer"}
                color={useColorModeValue("black", "white")}
              >
                History
              </Text>
            </Link>
          </Tooltip> */}

          <Tooltip
            hasArrow
            fontWeight={400}
            borderRadius={"6px"}
            fontSize={"sm"}
            px={4}
            py={1.5}
            label="Access Control"
          >
            <Link to={"/settings"} color={useColorModeValue("black", "white")}>
              <TbSettingsFilled
                fontSize={"20px"}
                cursor={"pointer"}
                color={useColorModeValue("black", "white")}
              />
            </Link>
          </Tooltip>

          <Tooltip
            hasArrow
            fontWeight={400}
            borderRadius={"6px"}
            fontSize={"sm"}
            px={4}
            py={1.5}
            label="Notifications"
          >
            <Center>
              <RiNotification4Fill
                fontSize={"20px"}
                cursor={"pointer"}
                color={useColorModeValue("black", "white")}
              />
            </Center>
          </Tooltip>
        </Flex>

        <Menu>
          <MenuButton>
            <Flex
              alignItems={"center"}
              gap={1}
              cursor={"pointer"}
              fontWeight={500}
            >
              <Text fontSize={16} display={["none", "none", "block", "block"]}>
                {user.name}
              </Text>
              <Avatar
                size={"2xs"}
                display={["block", "block", "none", "none"]}
              />
              <HiChevronDown fontSize={12} />
            </Flex>
          </MenuButton>
          <MenuList>
            <Link to={"/settings/admin/manage"}>
              <MenuItem
                display={"flex"}
                alignItems={"center"}
                fontWeight={500}
                fontSize={"md"}
                columnGap={2}
              >
                <MdManageAccounts fontSize={"24px"} />
                Manage Admins
              </MenuItem>
            </Link>

            <MenuItem fontWeight={500} fontSize={"md"} onClick={onOpenAlert}>
              <LogoutAlertDialog
                isOpen={isAlertOpen}
                onOpen={onOpenAlert}
                callback={logOut}
                onClose={onCloseAlert}
                title={"Logout"}
                heading={"Do you want to logout?"}
                icon={<MdOutlineLogout fontSize={"24px"} />}
                buttonViewContent={
                  <Text fontSize={"md"} fontWeight={500}>
                    Logout
                  </Text>
                }
              />
            </MenuItem>
          </MenuList>
        </Menu>
      </HStack>
    </Flex>
  );
};

export { Navbar };
